export default Object.freeze({
  transport: 'transportTax',
  property: 'propertyTax',
  land: 'landTax',
  income: 'incomeTax',
  taxPayment: 'singleTaxPayment',
  admPenalty: 'admPenaltyTax',
});
